import React, { useState } from "react";
import { Table, Select, Button, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import styles from "./MaterialMgmt.module.css";
import { useNavigate } from "react-router-dom";
import actionicon from "../../../../../assets/images/actionicon.svg";
import filtericon from "../../../../../assets/images/filter.svg";
import {
  Dropdown,
  Modal,
  SearchInput,
  TextComponent,
} from "../../../../../components";
import { SubmitButton } from "../../../../../components";
import HeaderComponent from "../../../../../components/HeaderComponent/HeaderComponent";
import { FaRegEye } from "react-icons/fa";
import { BiSolidEdit } from "react-icons/bi";
import { IoArchiveSharp } from "react-icons/io5";
import { ReactComponent as ViewIcon } from "../../../../../assets/images/view.svg";
import { ReactComponent as ArchiveIcon } from "../../../../../assets/images/archive.svg";

import { ReactComponent as EditIcon } from "../../../../../assets/images/editIcon.svg";
const { Option } = Select;

const MaterialMgmt = () => {
  const navigate = useNavigate();
  const [isModal, setIsModal] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [Category, setCategory] = useState({
    value: "Packaging Material",
    id: 1,
  });
  const [statuss, setStatus] = useState({
    value: "Active",
    id: 1,
  });

  const columns = [
    {
      title: "No",
      dataIndex: "No",
      key: "No",
    },
    {
      title: "Material Name",
      dataIndex: "MaterialName",
      key: "MaterialName",
      // render: (text, record) => (
      //   <div className={styles.ingredientCell}>
      //     <span>{text}</span>
      //     {(record.IngredientName === "Bread Flour" ||
      //       record.IngredientName === "Margarine" ||
      //       record.IngredientName === "Almonds") && (
      //         <img src={actionicon} alt="icon" className={styles.iconImg} />
      //       )}
      //   </div>
      // ),
    },
    {
      title: "Quantity",
      dataIndex: "Quantity",
      key: "Quantity",
    },
    {
      title: "Category",
      key: "Category",
      dataIndex: "Category",
    },
    {
      title: "Action",
      key: "Action",
      dataIndex: "Action",
      render: (text) => (
        <div className={styles.itemsButtonDiv}>
          <ViewIcon
            className={styles.itemsButton}
            onClick={() => navigate("/Warehouse/MaterialMGMT/AdjustStock")}
          />

          <EditIcon
            className={styles.itemsButton}
            onClick={() => navigate("/Warehouse/MaterialMGMT/EditMaterial")}
          />
          <ArchiveIcon
            className={styles.itemsButton}
            onClick={() => setIsModal(true)}
          />
        </div>
      ),
    },
    {
      title: "",
      key: "action",
      dataIndex: "Button",
      render: (text, record) => record.Button,
    },
  ];

  const data = [
    {
      No: "1",
      MaterialName: "Cardboard",
      Quantity: "2 lbs",
      Category: "Packaging Materials ",
      Action: "View",
    },
    {
      No: "2",
      MaterialName: "Plastic Containers",
      Quantity: "36 oz",
      Category: "Baking Tools",
      Action: "Edit",
    },
    {
      No: "3",
      MaterialName: "Paper Bags",
      Quantity: "3 lbs",
      Category: "Hygiene Supplies",
    },
    {
      No: "4",
      MaterialName: "Food-Grade Wrapping Film ",
      Quantity: "4 g",
      Category: "Decorating & Toppings",
    },
    {
      No: "5",
      MaterialName: "Cake Boards",
      Quantity: "36 oz",
      Category: "Packaging Materials ",
    },
    {
      No: "6",
      MaterialName: "Cardboard Boxes",
      Quantity: "3 lbs",
      Category: "Hygiene Supplies",
    },
    {
      No: "7",
      MaterialName: "Paper Bags",
      Quantity: "2 lbs",
      Category: "Decorating & Toppings",
    },
    {
      No: "8",
      MaterialName: "Plastic Containers",
      Quantity: "4 g",
      Category: "Baking Tools",
      Action: "Archive",
    },
    {
      No: "9",
      MaterialName: "Food-Grade Wrapping Film",
      Quantity: "3 lbs",
      Category: "Packaging Materials ",
      Action: "View",
    },
  ];

  const handleDisplayFilter = () => {
    setShowFilter(true);
  };

  return (
    <div className={styles.mainCont}>
      {/* Heading Section with Right Controls */}
      <HeaderComponent
        heading={"Material Management"}
        showFilterIcon={true}
        onClickFilter={() => handleDisplayFilter()}
        onSearch={(e) => console.log(e.target.value)}
        onSubmit={() => navigate("/Warehouse/MaterialMGMT/CreateNewMaterial")}
        submitButtonText={"Create New Material"}
        // showBackIcon={true}
        showSubmitButton={true}
        showSearch={true}
      />

      {/* Table Section */}
      <div className={styles.subCont}>
        <div className={styles.TableDiv}>
          <Table
            scroll={{ x: true }}
            columns={columns}
            dataSource={data}
            pagination={false}
            rowKey="No"
          />
        </div>
      </div>
      <Modal
        open={isModal}
        onClickOkButton={() => {
          setIsModal(false);
        }}
        onCancel={() => setIsModal(false)}
        className={styles.modalCont}
        title={"Archive"}
        headingClass={styles.modalHeading}
        width={"400px"}
        onClickCancelButton={() => setIsModal(false)}
        okBtnTitle={"Yes"}
        twoButton
        cancelBtnTitle={"No"}
        btnStyle={{ width: "200px", marginTop: "12px" }}
        onBtnPress={() => setIsModal(false)}
      >
        <div>
          <TextComponent
            text="Are you sure you want to archive? "
            className={styles.CardText}
          />
        </div>
      </Modal>

      {/* Filter Modal  */}

      <Modal
        open={showFilter}
        onClickOkButton={() => {
          setShowFilter(false);
        }}
        onCancel={() => setShowFilter(false)}
        className={styles.modalCont}
        title={"Filters"}
        headingClass={styles.modalHeading}
        width={"400px"}
        btnStyle={{ width: "200px", marginTop: "12px" }}
        twoButton
        onBtnPress={() => setShowFilter(false)}
        onClickCancelButton={() => setShowFilter(false)}
        okBtnTitle={"Apply Filters"}
        cancelBtnTitle={"Reset All"}
      >
        <Dropdown
          className={styles.input}
          label={"Category"}
          labelClass={styles.labelClass}
          value={Category}
          style={{ color: "var(--black-color)" }}
          options={[
            {
              value: "Packaging Material",
              id: 1,
            },
            {
              value: "Baking Tools",
              id: 2,
            },
            {
              value: "Hygiene Supplies",
              id: 3,
            },
            {
              value: "Decorating & Toppings",
              id: 4,
            },
          ]}
          onChange={(e) => setCategory(e)}
        />
        <Dropdown
          className={styles.input}
          label={"Status"}
          labelClass={styles.labelClass}
          value={statuss}
          style={{ color: "var(--black-color)" }}
          options={[
            {
              value: "Active",
              role: "active",
              id: 1,
            },
            {
              value: "Archived",
              role: "archived",
              id: 2,
            },
          ]}
          onChange={(e) => setStatus(e)}
        />
      </Modal>
    </div>
  );
};

export default MaterialMgmt;
